import React from 'react';
import VirtualList, { ItemStyle } from 'react-tiny-virtual-list';
import { ALIGNMENT } from 'react-tiny-virtual-list/types/constants';
import { FormSelectChoice } from '@sheerid/jslib';

interface InputSelectListProps {
    getItemProps: any;
    getMenuProps: any;
    highlightedIndex: number;
    itemToString: any;
    options: FormSelectChoice[];
}

const ROW_HEIGHT = 42;
const AUTO_SCROLL = 'auto' as ALIGNMENT.AUTO;

const InputSelectList = ({ getItemProps, getMenuProps, highlightedIndex, options, itemToString }: InputSelectListProps) => {
    const fullHeight = options.length * ROW_HEIGHT;
    const itemCount = options.length;

    const item = (index: number, style: ItemStyle) => {
        return (
            <div
                className={`sid-input-select-list__item ${highlightedIndex === index ? 'sid-input-select-list__item--highlighted' : ''}`}
                key={options[index].value}
                {...getItemProps({
                    style,
                    index,
                    item: options[index],
                })}
                >
                {itemToString(options[index])}
            </div>
        );
    };

    return(
        <VirtualList
            {...getMenuProps()}
            className={'sid-input-select-list__menu'}
            height={Math.min(fullHeight, 280)}
            itemCount={itemCount}
            itemSize={ROW_HEIGHT}
            renderItem={({ index, style }) => item(index, { ...style, width: 'auto' })}
            scrollToAlignment={AUTO_SCROLL}
            scrollToIndex={highlightedIndex || 0}
            width={'100%'}
        />
    );
};

export const InputSelectListComponent = InputSelectList;
